export default "__VITE_ASSET__FfMHrTE2__"